import { renderInline } from '../VueQuestion/coupDePouceTexte';
import { libelleExercices } from '../../utils/plancheAides';
import { formatDateFr } from './consignes';

/**
 * Planche de coups de pouce à découper — section de pages ajoutée en queue du
 * document papier, après le corrigé (décision prof 16/09).
 *
 * Le prof découpe les cartes et les pose sur son bureau ; l'élève bloqué sur
 * l'exercice 3 vient chercher la carte 3. La carte n'est JAMAIS sur la feuille
 * de l'exercice, garantie portée par le saut de page côté EvalPrintPage.
 *
 * Calqué sur `CorrectionsSection` : mêmes conventions, un en-tête de section
 * et un nœud par unité, tous deux des COMPOSANTS et non des fabriques
 * d'éléments — `block.exNum` doit être lu AU RENDU, puisque la numérotation
 * définitive est posée par `renumberBlocks` après pagination.
 */

export const PlancheHeading = ({ meta = {} }) => {
    const sousTitre = [meta.titre, meta.classe, formatDateFr(meta.date)].filter(Boolean).join(' · ');
    return (
        <div className="ep-cdp-head">
            <h2 className="ep-cdp-heading">Coups de pouce à découper</h2>
            {sousTitre && <span className="ep-cdp-sub">{sousTitre}</span>}
            <span className="ep-cdp-consigne">
                À donner à l&apos;élève qui bloque, une carte à la fois. Une seule impression suffit.
            </span>
        </div>
    );
};

/**
 * Une carte = une PAGE de fiche (décision prof 16/09) : l'élève prend le cas
 * qui le concerne grâce au titre, exactement comme les puces nommées de la
 * feuille élève. Une fiche à quatre pages donne quatre cartes.
 *
 * La figure est injectée EN LIGNE, jamais dans une balise image : dans une
 * image le SVG est un document isolé, ni la police des formules ni la police
 * système n'y résolvent, les métriques changent et le texte déborde du cadre.
 * En ligne, il hérite des polices déjà préchargées par la feuille.
 */
export const CarteAide = ({ carte }) => {
    const { page, indexPage, nbPages, blocs } = carte;
    const titreExos = libelleExercices(blocs);
    return (
        <article className="ep-cdp-carte" aria-label={`Coup de pouce, ${titreExos}, ${page.titre}`}>
            <div className="ep-cdp-entete">
                <span className="ep-cdp-exo">{titreExos}</span>
                <span className="ep-cdp-titre">{page.titre}</span>
                {nbPages > 1 && (
                    <span className="ep-cdp-compteur">aide {indexPage + 1}/{nbPages}</span>
                )}
            </div>

            {page.court && <p className="ep-cdp-court">{renderInline(page.court)}</p>}

            {Array.isArray(page.lignes) && page.lignes.length > 0 && (
                <ol className="ep-cdp-lignes">
                    {page.lignes.map((ligne, i) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <li key={i} className="ep-cdp-ligne">{renderInline(ligne)}</li>
                    ))}
                </ol>
            )}

            {page.svg && (
                <div
                    className="ep-cdp-figure"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: page.svg }}
                />
            )}
        </article>
    );
};

export default CarteAide;
